import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Download, Printer } from "lucide-react";
import { toast } from "sonner";
import { useReportBrand } from "../reports/useReportBrand";
import { exportHistoryCsv } from "./historyExport";
import { openRequestsListOverlay } from "./requestsListDoc";
import { RAISED3D } from "./neu3d";

const BTN = "flex items-center gap-1.5 rounded-2xl px-3 py-1.5 text-xs font-black text-white [text-shadow:0_1px_2px_rgba(0,0,0,.4)] transition-transform duration-150 hover:-translate-y-0.5 active:translate-y-0.5 disabled:opacity-60";

// شريط تصدير سجل الطلبات: Excel (أخضر) + PDF (أحمر) بأزرار بارزة 3D Neu قوية، بنفس الحجم.
export const HistoryExportBar = ({ rows, headers, title }) => {
  const { t, i18n } = useTranslation();
  const brand = useReportBrand();
  const [busy, setBusy] = useState(false);

  const openPdf = async () => {
    setBusy(true);
    try {
      await openRequestsListOverlay(title, rows, headers, i18n.language, brand);
    } catch {
      toast.error(t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex gap-2.5">
      <button type="button" data-testid="history-export-excel" style={{ boxShadow: RAISED3D }}
        className={`${BTN} bg-gradient-to-b from-emerald-400 to-emerald-600`}
        onClick={() => exportHistoryCsv(rows, headers, `${title}.csv`)}>
        <Download className="h-4 w-4" /> {t("requests.exportExcel")}
      </button>
      <button type="button" data-testid="history-print" style={{ boxShadow: RAISED3D }} disabled={busy}
        className={`${BTN} bg-gradient-to-b from-rose-400 to-rose-600`} onClick={openPdf}>
        <Printer className="h-4 w-4" /> {t("requests.print")}
      </button>
    </div>
  );
};
